import { render, staticRenderFns } from "./menu-tag.vue?vue&type=template&id=f96ef906&scoped=true"
import script from "./menu-tag.vue?vue&type=script&lang=ts"
export * from "./menu-tag.vue?vue&type=script&lang=ts"
import style0 from "./menu-tag.vue?vue&type=style&index=0&id=f96ef906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96ef906",
  null
  
)

export default component.exports